<template>

    <div class="personal-section__item" data-personal-item="" :data-personal-id="account.PersonAccountId">
        <div class="personal-card card">
            <div class="personal-card__body">
                <div class="personal-card__head">
                    <div class="personal-card__title h3">
                        Номер лицевого счета:
                        <span class="status-error" v-if="account.Status == 1">{{account.AccountNumber}}</span>
                        <span class="status-success" v-if="account.Status !== 1">{{account.AccountNumber}}</span>
                    </div>
                    <div class="personal-card__state" v-if="account.Status == 1">
                        <span>Статус: </span>
                        <span>{{account.StatusCaption}}</span>
                    </div>
                    <div class="personal-card__remove">
                        <a href="" class="button-icon button-icon--th-remove" v-bind:data-drop-toggle="'personalModal_'+account.PersonAccountId"><i class="icon icon--remove"></i></a>
                    </div>
                </div>
                <div class="personal-card__caption">
                    <div class="personal-card__item">
                        <span>Адрес:</span>
                        {{account.Address}}
                    </div>
                    <div class="personal-card__item">
                        <span>Потребитель:</span>
                        {{account.Consumer}}
                    </div>
                    <div class="personal-card__item">
                        <span>Город:</span>
                        {{account.City}}
                    </div>
                </div>
            </div>
            <div class="personal-card__icon">
                <img src="/images/card-head-icons/individual.svg" alt="">
            </div>

            <div v-bind:id="'personalModal_'+account.PersonAccountId" class="personal-card__drop card">
                <div class="personal-card__drop-inner">
                    <div class="personal-card__subtitle h3">Вы действительно хотите удалить этот лицевой счет?</div>
                    <div class="personal-card__ctrl h3">
                        <a href="" class="button button--th-second" v-on:click="deleteAccount();$emit('close')">Да</a>
                        <a href="" class="button button--th-link" v-bind:data-drop-toggle="'personalModal_'+account.PersonAccountId">Нет</a>
                    </div>
                </div>
            </div>
        </div>
        <!--<a href="#personalSection_0" class="personal-section__ctrl link link--primary" data-toggle-not="collapse">
            <span class="link__text">Управление рассылкой и настройки</span>
        </a>-->
        <div id="personalSection_0" class="personal-section__drop accordion-body collapse">
            <div class="personal-section__inner accordion-body__inner">
                <div class="settings">
                    <form action="">
                        <div class="settings__item head-card head-card--fill card">
                            <div class="head-card__body">
                                <div class="head-card__title h3">Настройки рассылки платежных документов:</div>
                                <div class="head-card__caption">Подпишитесь на получение счетов, Lorem ipsum – псевдо-латинский текст, который используется для веб дизайна, типографии, оборудования, и распечатки вместо английского</div>
                            </div>
                            <div class="head-card__icon">
                                <img src="/sgk.epp/images/card-head-icons/docs.svg" alt="">
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Получение Бумажного ЕПД</div>
                                    <div class="data-card__caption">
                                        ЕПД — это единый платежный документ размером
                                        А4+ (228 на 450 миллиметров). Документ отправляют
                                        без конверта, но сложенным и запечатанным по краям
                                    </div>
                                </div>
                                <div class="data-card__right data-card__right--revere">
                                    <label class="switch switch--right">
                                        <input class="switch__checkbox" data-toggle-switch="" data-target="#dataCard_0" type="checkbox">
                                        <div class="switch__label">
                                            <div class="switch__text">Нет</div>
                                            <div class="switch__text _last">Да</div>
                                        </div>
                                        <div class="switch__view"></div>
                                    </label>
                                </div>
                            </div>
                            <div id="dataCard_0" class="data-card__form data-card__form--sm accordion-body collapse">
                                <div class="data-card__inner accordion-body__inner">
                                    <div class="small-form">
                                        <div class="small-form__body">
                                            <div class="small-form__input">
                                                <label class="txt-input">
                                                    <div class="txt-input__input">
                                                        <input class="txt-input__field input" type="text" placeholder="Введите код">
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="small-form__submit">
                                                <a href="" class="button button--th-second" data-drop-toggle="modalPhoneSubmit">Подвердить</a>
                                            </div>
                                        </div>
                                        <div class="small-form__caption">
                                            Введите код который мы отправили по СМС на номер 8 (913) 556 55 55
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Рассылка Электронного ЕПД на email</div>
                                    <div class="data-card__caption">
                                        Введите email чтобы получать рассылку платежей по электронной почте
                                    </div>
                                </div>
                                <div class="data-card__right data-card__right--revere">
                                    <label class="switch switch--right">
                                        <input class="switch__checkbox" data-toggle-switch="" data-target="#dataCard_1" type="checkbox">
                                        <div class="switch__label">
                                            <div class="switch__text">Нет</div>
                                            <div class="switch__text _last">Да</div>
                                        </div>
                                        <div class="switch__view"></div>
                                    </label>
                                </div>
                            </div>
                            <div id="dataCard_1" class="data-card__form data-card__form--sm accordion-body collapse">
                                <div class="data-card__inner accordion-body__inner">
                                    <div class="small-form">
                                        <div class="small-form__body">
                                            <div class="small-form__input">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">Введите e-mail для рассылки:</div>
                                                    <div class="txt-input__input">
                                                        <input class="txt-input__field input" type="text" placeholder="ivan2008@email.ru">
                                                        <div class="txt-input__sup">
                                                            <i class="icon icon--check"></i>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="small-form__submit">
                                                <button class="button button--th-second" type="submit">Подписаться</button>
                                            </div>
                                        </div>
                                        <div class="small-form__caption">Мы отправили сообщение вам на почту ivan2008@email.ru, следуйте инструкции для подтверждения</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Просмотр Электроннго ЕПД на сайте и в МП</div>
                                </div>
                                <div class="data-card__right data-card__right--revere">
                                    <label class="switch switch--right">
                                        <input class="switch__checkbox" type="checkbox">
                                        <div class="switch__label">
                                            <div class="switch__text">Нет</div>
                                            <div class="switch__text _last">Да</div>
                                        </div>
                                        <div class="switch__view"></div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item head-card head-card--fill card">
                            <div class="head-card__body">
                                <div class="head-card__title h3">Настройки SMS и e-mail рассылок:</div>
                                <div class="head-card__caption">Настройте удобный доступ к уведомлениям</div>
                            </div>
                            <div class="head-card__icon">
                                <img src="/sgk.epp/images/card-head-icons/email.svg" alt="">
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о задолженности</div>
                                    <div class="data-card__caption">Даты рассылки 10-15 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о сроке передаче показаний</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о задолженности</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__item data-card block">
                            <div class="data-card__head">
                                <div class="data-card__subhead">
                                    <div class="data-card__title h3">Информирование о сроке передаче показаний</div>
                                    <div class="data-card__caption">Даты рассылки 20-25 число месяца</div>
                                </div>
                                <div class="data-card__right">
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">SMS</span>
                                    </label>
                                    <label class="cb-input">
                                        <input class="cb-input__checkbox" type="checkbox">
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">E-Mail</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="settings__confirm card">
                            <div class="settings__caption">
                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца.
                            </div>
                            <div class="settings__ctrl">
                                <a href="" class="button button--th-second">Сохранить</a>
                                <a href="#personalSection_0" class="button button--th-link" data-toggle="collapse">Отменить</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import modalDeleteAccount from './ModalDeleteAccount.vue'


    export default {
        components: {
            modalDeleteAccount
        },

        props: ['account'],

        data: function () {
            return {
                confirmDelete: false
            }
        },

        computed: {
            cotractDate: function () {
                return '';
                if (this.account.ContractDate) {
                    return new Date(this.account.ContractDate).toLocaleDateString("ru-RU");
                } else {
                    return '';
                }
            },
            contract: function () {
                return '';
                return `${this.account.ContragentShortName}
                    ${!!this.account.ContractNumber ? '№ ' + this.account.ContractNumber : ''}
                    ${!!this.cotractDate ? 'от ' + this.cotractDate : ''}
                    ${!!this.account.Division.Caption ? 'с ' + this.account.Division.Caption : ''}`
            }
        },

        methods: {
            deleteAccount: function () {
                var id = this.$el.getAttribute('data-personal-id');
                if (id != undefined) {
                    axios.post("/fl/accounts/remove/" + id);
                }
            }
            //onRemoveComponent: function () {
            //    this.componentVisible = false;
            //}
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/PersonalAccount.vue